import React, { useState } from 'react';
import './UserManagement.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const UserManagement = () => {

    const [users, setUsers] = useState([
        { id: 1, name: "Vishal Preetham", email: "vishal@example.com", status: "Active" },
        { id: 2, name: "Ravi Kumar", email: "ravi@example.com", status: "Active" },
        { id: 3, name: "Anitha Reddy", email: "anitha@example.com", status: "Inactive" },
        { id: 4, name: "Mahesh", email: "mahesh@example.com", status: "Active" },
    ]);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [newUser, setNewUser] = useState({ name: "", email: "", status: "Active" });
    const [selectedUser, setSelectedUser] = useState(null);

    const handleAddUser = () => {
        if (!newUser.name || !newUser.email) {
            alert("Please fill all fields");
            return;
        }

        const userToAdd = {
            id: users.length + 1,
            ...newUser,
        };

        setUsers([...users, userToAdd]);
        setNewUser({ name: "", email: "", status: "Active" });
        setShowAddModal(false);
    };

    const openEditModal = (user) => {
        setSelectedUser({ ...user });
        setShowEditModal(true);
    };

    const handleEditUser = () => {
        setUsers(users.map(u =>
            u.id === selectedUser.id ? selectedUser : u
        ));
        setShowEditModal(false);
    };

    return (
        <div className="user-management">
            <div className="um-header">
                <div>
                    <h2>User Management</h2>
                    <p>Manage users and their status</p>
                </div>
                <button className="add-user-btn" onClick={() => setShowAddModal(true)}>
                    + Add User
                </button>
            </div>

            <div className="um-table-wrapper">
                <table className="um-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>
                                    <span className={`status ${user.status.toLowerCase()}`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td>
                                    <button className="edit-btn" onClick={() => openEditModal(user)}>
                                        Edit
                                    </button>
                                    <button className="delete-btn">
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* -------- ADD USER MODAL -------- */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                value={newUser.name}
                                onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                value={newUser.email}
                                onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Status</label>
                            <select
                                className="form-control"
                                value={newUser.status}
                                onChange={(e) => setNewUser({ ...newUser, status: e.target.value })}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleAddUser}>
                        Save User
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* -------- EDIT USER MODAL -------- */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedUser && (
                        <form>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={selectedUser.name}
                                    onChange={(e) =>
                                        setSelectedUser({ ...selectedUser, name: e.target.value })
                                    }
                                />
                            </div>

                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={selectedUser.email}
                                    onChange={(e) =>
                                        setSelectedUser({ ...selectedUser, email: e.target.value })
                                    }
                                />
                            </div>

                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={selectedUser.status}
                                    onChange={(e) =>
                                        setSelectedUser({ ...selectedUser, status: e.target.value })
                                    }
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleEditUser}>
                        Update User
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UserManagement;
